import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
// eslint-disable-next-line no-restricted-imports

/**
 * WordPress dependencies
 */
import { isValidElement } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { getValidChildren } from '../ui/utils/get-valid-children';
import { contextConnect, useContextSystem } from '../ui/context'; // eslint-disable-next-line no-duplicate-imports

import { ZStackView, ZStackChildView } from './styles';

function ZStack(props, forwardedRef) {
  const {
    children,
    className,
    isLayered = true,
    isReversed = false,
    offset = 0,
    ...otherProps
  } = useContextSystem(props, 'ZStack');
  const validChildren = getValidChildren(children);
  const childrenLastIndex = validChildren.length - 1;
  const clonedChildren = validChildren.map((child, index) => {
    const zIndex = isReversed ? childrenLastIndex - index : index;
    const offsetAmount = offset * index;
    const key = isValidElement(child) ? child.key : index;
    return createElement(ZStackChildView, {
      isLayered: isLayered,
      offsetAmount: offsetAmount,
      zIndex: zIndex,
      key: key
    }, child);
  });
  return createElement(ZStackView, _extends({}, otherProps, {
    className: className,
    ref: forwardedRef
  }), clonedChildren);
}

export default contextConnect(ZStack, 'ZStack');
//# sourceMappingURL=component.js.map